import './FormFieldset.scss';

const FormFieldset = props => (
  <div className="formFieldset">{props.children}</div>
);

export default FormFieldset;
